import exchangeCard from "./exchangeCard";

export default exchangeCard
